import { styled } from '@stitches/configed';

const Box = styled('div', {
  position: 'relative',
  padding: 24,
  backgroundColor: '$surface1',
  transition: 'all .5s ease-in-out',
  border: '0px solid transparent',
  borderRadius: '1.75rem',
  boxShadow: '0px 12px 25px 0px rgb(0 0 0 / 4%)',
});

export default Box;
